<template>
  <v-container
    id="statsModule"
    class="pt-2 mt-2"
    fill-height
    fluid
    grid-list-xl
  >
    <!-- Admin Section -->
    <v-layout justify-center wrap>
      <v-flex xs12 class="py-0">
        <p style="font-weight: bold" class="my-0">
          Showcasing what type of buyers have enquired with upstream that have
          tagged you as the Good Cause
        </p>
      </v-flex>
      <v-flex xs12 class="pt-0" style="height: 70vh">
        <apexChart
          v-if="chartLoaded"
          height="100%"
          :options="options"
          :series="series"
        ></apexChart>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import apexChart from "@/components/wrappers/apexChart.vue";

export default {
  components: { apexChart },

  data: () => ({
    series: [],
    options: {
      colors: ["#58595b", "#68c6b3", "#4cc7e8"],

      chart: {
        type: "bar",
        height: 350,
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "55%",
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        show: true,
        width: 2,
        colors: ["transparent"],
      },
      xaxis: {
        categories: [],
        labels: {
          maxHeight: 180,
        },
      },
      yaxis: {
        title: {
          text: "Count",
        },
      },
      fill: {
        opacity: 1,
      },
      tooltip: {
        y: {
          formatter: function(val) {
            return val + `${val < 2 ? " Enquiry" : " Enquiries"}`;
          },
        },
      },
    },
    chartLoaded: false,
  }),
  computed: {
    ...mapGetters({
      user: "user",
      userData: "user/userData",
      stats: "stats/goodCauseSalesEnquiryBuyerTypeStats",
    }),
  },
  watch: {
    stats: function() {
      this.updateStats();
    },
  },
  mounted() {
    this.$store.dispatch(
      "stats/goodCauseSalesEnquiryBuyerTypeStatsLoadByID",
      this.userData.admin_goodCause_id
    );
    this.updateStats();
  },
  methods: {
    updateStats() {
      this.series = [
        {
          name: "Fallen Through",
          data: [],
        },
        {
          name: "Completed",
          data: [],
        },
        {
          name: "Still Active",
          data: [],
        },
      ];
      let dataCounts = {};
      this.options.xaxis.categories = [];
      if (this.stats.length > 0) {
        this.stats.forEach((element) => {
          let buyerType = "";
          if (element.impactBuyerType == "") {
            buyerType = "Consumer";
          } else {
            buyerType = element.impactBuyerType;
          }
          if (!dataCounts.hasOwnProperty(buyerType)) {
            dataCounts[buyerType] = {
              pending: 0,
              fallenThrough: 0,
              completed: 0,
            };
          }

          if (element.upstreamStatus == "Fallen Through") {
            dataCounts[buyerType].fallenThrough += parseInt(element.Count);
          } else if (element.upstreamStatus == "Completed") {
            dataCounts[buyerType].completed += parseInt(element.Count);
          } else {
            dataCounts[buyerType].pending += parseInt(element.Count);
          }
          if (!this.options.xaxis.categories.includes(buyerType)) {
            this.options.xaxis.categories.push(buyerType);
          }
        });

        for (const element in dataCounts) {
          this.series[0].data.push(dataCounts[element].fallenThrough);
          this.series[1].data.push(dataCounts[element].completed);
          this.series[2].data.push(dataCounts[element].pending);
        }
        if (this.$vuetify.breakpoint.smAndDown) {
          this.options.plotOptions.horizontal = true;
        }
        this.chartLoaded = true;
      }
    },
  },
};
</script>
